import { useState } from 'react'
import { useSelector } from 'react-redux'
import hanhDongChinhSua from '../../../constant/hanhDongChinhSua'
import chinhSuaVanBangProcessor from '../../../processor/chinhSuaVanBangProcessor'
import ListVanBangWithView from '../ListVanBangWithView'

const processor = chinhSuaVanBangProcessor
export default function DieuChinhVanBang() {
  const toast = useSelector((store) => store.notify.toast)
  const confirm = useSelector((store) => store.notify.confirm)
  const [reload, setReload] = useState(false)

  const onSubmit = async (id) => {
    const dieuChinh = { vanBangId: id, type: hanhDongChinhSua.trinhDuyet }
    const rs = await processor.upsert(dieuChinh)
    toast({
      type: rs.isSuccess ? 'success' : 'error',
      message: rs.isSuccess ? 'Chuyển yêu cầu thành công' : 'Chuyển yêu cầu thất bại',
    })
    if (rs.isSuccess) setReload(true)
  }

  const buttons = [
    (data) => {
      return {
        icon: 'pi pi-pencil',
        className: 'p-button-rounded p-button-success mr-2',
        tooltip: 'Sửa',
        tooltipOptions: { position: 'top' },
        onClick: () => {
          confirm({
            action: () => onSubmit(data.id),
            body: `Bạn có chắc thực hiện chỉnh sửa thông tin văn bằng ?`,
          })
        },
        disabled: data.stateChinhSua !== 0,
      }
    },
  ]

  return (
    <>
      <ListVanBangWithView
        additionColumn={[]}
        moduleTitle="Danh sách văn bằng"
        buttons={buttons}
        getMethod={processor.getByKhoaThi}
        reload={reload}
        setReload={setReload}
      />
    </>
  )
}
